import React from 'react'
import './loader.styles.css'

const Loader = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} className={`loader ${props.className || ''}`} viewBox="0 0 100 100">
      <linearGradient id="loaderGradient">
        <stop offset="0%" stopColor="#6b6c6f00" />
        <stop offset="75%" stopColor="#6b6c6f99" />
      </linearGradient>
      <circle
        fill="transparent"
        stroke="url(#loaderGradient)"
        strokeWidth="12"
        className="loader__icon"
        r="40"
        cx="50"
        cy="50"
      />
    </svg>
  )
}

export const LoaderRow = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <div className="loader__row">
      <Loader {...props} />
    </div>
  )
}

export default Loader
